// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4874404f","389":"6818ca6d","453":"70f1f126","455":"ec19245f","857":"14bba924","977":"3e9ad8a4"}[chunkId] + ".chunk.js";
};